import { component } from 'picoapp';
import Swiper, { Pagination } from 'swiper';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const sliderElement = node.querySelector('.js-slider') ? node.querySelector('.js-slider') : node;
  const sliderPagination = node.querySelector('.js-sliderPagination') ? node.querySelector('.js-sliderPagination') : node;

  /**
   * Functions
   */
  const initSlider = () => {
    (() => new Swiper(sliderElement, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 16,
      threshold: 5,
      lazy: true,
      grabCursor: true,
      pagination: {
        el: sliderPagination,
        type: 'bullets',
        bulletClass: 'image-slider__page-bullet',
        bulletActiveClass: 'image-slider__page-bullet--active',
      },
    }))();
  };

  const init = () => {
    initSlider();
  };

  /**
   * Init
   */
  init();
});
